import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=4b2b13db"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2b13db')) {
      api.createRecord('4b2b13db', component.options)
    } else {
      api.reload('4b2b13db', component.options)
    }
    module.hot.accept("./Invite.vue?vue&type=template&id=4b2b13db", function () {
      api.rerender('4b2b13db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/pages/Invite.vue"
export default component.exports